export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14792.03c66bd5.jpg";